import { render, staticRenderFns } from "./StallionMare.vue?vue&type=template&id=728a7d38&"
import script from "./StallionMare.vue?vue&type=script&lang=js&"
export * from "./StallionMare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports